import { render } from "./LateralButtons.vue?vue&type=template&id=0bd918a2&scoped=true"
import script from "./LateralButtons.vue?vue&type=script&lang=js"
export * from "./LateralButtons.vue?vue&type=script&lang=js"

import "./LateralButtons.vue?vue&type=style&index=0&id=0bd918a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd918a2"]])

export default __exports__